import { Contract, ContractStatus } from '../types'

import type { ChargingContractResource } from '@/api/generated/engageUIApiEndpoints.schemas'
import { valueOrEmpty } from '@/util/string-util'

export const mapChargingContractToContract = (resource: ChargingContractResource): Contract => {
  return {
    contractId: resource.id,
    contractNumber: valueOrEmpty(resource.contractNumber),
    emaId: resource.chargingAccount.emaId,
    billingAccountId: valueOrEmpty(resource.billing.accountIdExternal),
    salesPartnerCustomerReference: valueOrEmpty(resource.contractSalesPartner?.salesPartnerCustomerReferenceId),
    email: resource.communication.emailAddress,
    firstName: resource.personalData.firstName,
    lastName: resource.personalData.lastName,
    streetAndHouseNumber: buildStreetHouseNumber(resource.address.street, resource.address.houseNumber),
    postalCodeAndCity: buildPostalCodeCity(resource.address.postalCode, resource.address.city),
    contractStatus: determineContractStatus(resource.termination)
  }
}

export const mapChargingContractsToContracts = (resources: ChargingContractResource[]): Contract[] => {
  return resources.map(mapChargingContractToContract)
}

const buildStreetHouseNumber = (street?: string, houseNumber?: string): string => {
  const parts = [street, houseNumber].filter(Boolean)
  return parts.join(' ')
}

const buildPostalCodeCity = (postalCode?: string, city?: string): string => {
  const parts = [postalCode, city].filter(Boolean)
  return parts.join(' ')
}

const determineContractStatus = (termination: ChargingContractResource['termination']): ContractStatus => {
  if (!termination?.terminateAt) {
    return ContractStatus.Active
  }

  const terminationDate = new Date(termination.terminateAt)
  const now = new Date()

  if (terminationDate <= now) {
    return ContractStatus.Terminated
  }

  return ContractStatus.InTermination
}
